<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 환경에너지예산-->
    <group-data-table
      class="mt-6"
      ref="group-data-table"
      title="환경에너지예산"
      annotation="(단위:백만원)"
      :groups="groups"
      :fixedItems="fixedItems"
      v-model="form.환경에너지예산"
    >
      <template v-slot:colgroup>
        <col width="218">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
      </template>
      <template v-slot:thead>
        <tr>
          <th rowspan="2" colspan="1" class="cursor-pointer" @click="toggleOpenAll">항목</th>
          <th rowspan="1" colspan="4" >예산</th>
          <th rowspan="2" colspan="1" >지출액</th>
          <th rowspan="2" colspan="1" >지출잔액</th>
          <th rowspan="2" colspan="1" >집행률(%)</th>
        </tr>
        <tr>
          <th>편성액</th>
          <th>본예산</th>
          <th>추경예산</th>
          <th>결산추경</th>
        </tr>
      </template>
      <template v-slot:group-tr="{ group, data }">
        <td><div class="print-input">{{ getTotalData("편성액", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("본예산", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("추경예산", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("결산추경", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("지출액", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("지출잔액", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("집행률", group, data) | fixed(2) }}</div></td>
      </template>
      <template v-slot:tr="{ group, data }">
        <td><div class="print-input">{{ data['편성액'] || 0 | comma }}</div></td>
        <td><number-input v-model="data['본예산']" @input="onChangeData(data)"/></td>
        <td><number-input v-model="data['추경예산']" @input="onChangeData(data)"/></td>
        <td><number-input v-model="data['결산추경']" @input="onChangeData(data)"/></td>
        <td><number-input v-model="data['지출액']" @input="onChangeData(data)"/></td>
        <td><div class="print-input">{{ data['지출잔액'] || 0 | comma }}</div></td>
        <td><div class="print-input">{{ data['집행률'] | fixed(2) }}</div></td>
      </template>
      <template v-slot:tfoot>
        <tr>
          <th class="py-4">계</th>
          <td><div class="print-input">{{ getTotalData("편성액", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("본예산", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("추경예산", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("결산추경", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("지출액", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("지출잔액", "", form.환경에너지예산) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("집행률", "", form.환경에너지예산) | fixed(2) }}</div></td>
        </tr>
      </template>
    </group-data-table>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import {required} from "vuelidate/lib/validators";
import NumberInput from "@/components/NumberInput.vue";
import GroupDataTable from "@/components/group-data-table/GroupDataTable.vue";
import excelSupporter from "@/excelSupporter";

export default {
  components: {
    GroupDataTable,
    NumberInput,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      groups: [
        "환경 시설투자", "환경 관리 인건비", "환경 시설 운영비", "폐기물 처리비", "환경 컨설팅", "환경 측정비", "교육훈련비"
      ],
      fixedItems: {},
      form: {
        stdInfo: {},
        환경에너지예산: {},
        total: {},
        fileList: [],
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        if (Object.keys(value.환경에너지예산).length > 0) {
          for (const key of ["편성액", "본예산", "추경예산", "결산추경", "지출액", "지출잔액", "집행률"]) {
            value.total[key] = this.getTotalData(key, "", value.환경에너지예산);
          }
        }

        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
    // tab-items.js 에서 useExcelDownload 설정을 했을 때, [Excel 내려받기]를 클릭시 호출 되는 함수
    excelDownload() {
      return {
        resource: "/excel/동국제강_환경에너지예산_엑셀등록.xlsx",
        fileName: `환경에너지예산_${new Date().format('yyyy-MM-dd')}.xlsx`,
        applyDataToSheet: (worksheet) => {
          // 사업장명
          worksheet.getCell('H1').value = this.form.stdInfo.field_name
          // 대상년도
          worksheet.getCell('H2').value = this.header.year
          // 대상월
          worksheet.getCell('H3').value = this.header.month

          console.log("worksheet", worksheet.getCell('A6'))

          // worksheet.addRow 를 사용하여 행 추가시 빈 행이 발생하므로, 빈 행을 제거
          if (worksheet.rowCount >= 8) {
            worksheet.spliceRows(8, 1);
          }

          // 항목: A
          // 예산-편성액: B
          // 예산-본예산: C
          // 예산-추경예산: D
          // 예산-결산추경: E
          // 지출액: F
          // 지출잔액: G
          // 집행률: H
          let rowIndex = 7;
          const groups = this.groups;
          for (const group of groups) {
            rowIndex++;
            let groupSize = this.form.환경에너지예산[group].data.length;
            excelSupporter.addHeader(worksheet, [
              {value: group, style: 'bg-borderHead', merge: 'A:A'},
              {value: groupSize > 0 ? { formula: `SUM(B${rowIndex+1}:B${rowIndex+groupSize})` } : 0, style: 'border', merge: 'B:B'},
              {value: groupSize > 0 ? { formula: `SUM(C${rowIndex+1}:C${rowIndex+groupSize})` } : 0, style: 'border', merge: 'C:C'},
              {value: groupSize > 0 ? { formula: `SUM(D${rowIndex+1}:D${rowIndex+groupSize})` } : 0, style: 'border', merge: 'D:D'},
              {value: groupSize > 0 ? { formula: `SUM(E${rowIndex+1}:E${rowIndex+groupSize})` } : 0, style: 'border', merge: 'E:E'},
              {value: groupSize > 0 ? { formula: `SUM(F${rowIndex+1}:F${rowIndex+groupSize})` } : 0, style: 'border', merge: 'F:F'},
              {value: groupSize > 0 ? { formula: `SUM(G${rowIndex+1}:G${rowIndex+groupSize})` } : 0, style: 'border', merge: 'G:G'},
              {value: { formula: `IF(F${rowIndex}<>0, F${rowIndex}/B${rowIndex}*100, 0)`}, style: 'border', merge: 'H:H'},
            ]);
            if (this.form.환경에너지예산[group].data.length > 0) {
              for (const item of this.form.환경에너지예산[group].data) {
                rowIndex++;
                excelSupporter.addHeader(worksheet, [
                  {value: item.group, style: 'borderHead', merge: 'A:A'},
                  {value: { formula: `SUM(C${rowIndex}:E${rowIndex})` }, style: 'border', merge: 'B:B'},
                  {value: Number(item.data.본예산 || 0), style: 'border', merge: 'C:C'},
                  {value: Number(item.data.추경예산 || 0), style: 'border', merge: 'D:D'},
                  {value: Number(item.data.결산추경 || 0), style: 'border', merge: 'E:E'},
                  {value: Number(item.data.지출액 || 0), style: 'border', merge: 'F:F'},
                  {value: { formula: `B${rowIndex}-F${rowIndex}` }, style: 'border', merge: 'G:G'},
                  {value: '', style: 'border', merge: 'H:H'},
                ]);
              }
            }
          }

          // 계
          rowIndex++;
          excelSupporter.addHeader(worksheet, [
            {value: '계', style: 'bg-borderHead', merge: 'A:A'},
            {value: { formula: `SUM(B8:B${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'B:B'},
            {value: { formula: `SUM(C8:C${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'C:C'},
            {value: { formula: `SUM(D8:D${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'D:D'},
            {value: { formula: `SUM(E8:E${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'E:E'},
            {value: { formula: `SUM(F8:F${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'F:F'},
            {value: { formula: `SUM(G8:G${rowIndex-1})/2` }, style: 'bg-borderHead', merge: 'G:G'},
            {value: { formula: `F${rowIndex}/B${rowIndex}*100` }, style: 'border', merge: 'H:H'},
          ]);
        }
      }
    },

    toggleOpenAll () {
      this.$refs["group-data-table"].toggleOpenAll();
    },

    getTotalData(key, group, data) {
      const _totalData = (key, group, _data) => {
        if (_data && _data.length > 0) {
          if (key === '집행률') {
            const 지출액 = _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['지출액'] || 0);
            }, 0);
            const 편성액 = data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['편성액'] || 0);
            }, 0);
            return (지출액 * 100) / 편성액;
          } else {
            return _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data[key] || 0);
            }, 0);
          }
        }
        return 0;
      }
      if (group) {
        return _totalData(key, group, data);
      } else if (key === '집행률') {
        let 편성액 = 0;
        let 지출액 = 0;
        for (const group of this.groups) {
          편성액 += _totalData('편성액', group, data[group].data);
          지출액 += _totalData('지출액', group, data[group].data);
        }
        return (지출액 * 100) / 편성액;
      } else {
        return this.groups.reduce((acc, cur) => {
          return Number(acc || 0) + Number(_totalData(key, cur, data[cur].data) || 0);
        }, 0);
      }
    },
    onChangeData (data) {
      const {
        본예산 = 0,
        추경예산 = 0,
        결산추경 = 0,
        지출액 = 0
      } = data;
      data["편성액"] = Number(본예산 || 0) + Number(추경예산 || 0) + Number(결산추경 || 0);
      data["지출잔액"] = data["편성액"] - Number(지출액 || 0);
      data["집행률"] = (Number(지출액 || 0) * 100) / data["편성액"];
    }
  }
};
</script>
<style lang="scss" scoped>
.print-input {
  background-color: #fafafa;
}
</style>
